export default __webpack_public_path__ + "static/media/newUser.72c4d0a0.png";